import { useContent } from "contexts/contentContext/contentContext";
import { forwardRef, useImperativeHandle, useState } from "react";
import Turnstile, { useTurnstile, type TurnstileProps } from "react-turnstile";

interface CloudflareCaptchaI extends TurnstileProps {}

const CloudflareCaptcha = forwardRef((props: CloudflareCaptchaI, ref) => {
  const { getBasicSettingsData } = useContent();
  const turnstile = useTurnstile();
  const [widgetId, setWidgetId] = useState<string | null>(null);

  useImperativeHandle(ref, () => ({
    executeAsync: async () => await turnstile?.execute?.(widgetId),
    getResponse: () => turnstile?.getResponse(widgetId),
    reset: () => turnstile?.reset(widgetId),
  }));

  if (getBasicSettingsData()?.recaptchaType === "google") {
    return null;
  }

  return (
    <>
      <Turnstile
        onLoad={async (widgetId) => {
          setWidgetId(widgetId);
        }}
        size="invisible"
        execution="render"
        appearance="always"
        {...props}
        action={props.action || "default"}
      />
    </>
  );
});

export default CloudflareCaptcha;
